export default __webpack_public_path__ + "static/media/lochinvar.050ffd2e.jpg";